// Query-keys factory for the orders module. Every read / invalidation
// goes through this — never raw array literals.

import type { GetOrdersListParams, PendingApprovalQueueParams } from '../types/orderTypes'

export const ordersQueryKeys = {
  all: ['orders'] as const,
  lists: () => [...ordersQueryKeys.all, 'list'] as const,
  list: (params: GetOrdersListParams) => [...ordersQueryKeys.lists(), params] as const,
  details: () => [...ordersQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...ordersQueryKeys.details(), id] as const,
  // Under lists() so mutations that invalidate lists() also refresh the counts.
  vaspStatusCounts: () => [...ordersQueryKeys.lists(), 'vasp-status-counts'] as const,
  pendingApprovalCount: () => [...ordersQueryKeys.lists(), 'pending-approval-count'] as const,
  // The whole `paid` queue in one entry, grouped by offering on read. Under
  // lists() so approve / reject / cancel already refresh it.
  pendingApprovalQueue: (params: PendingApprovalQueueParams) =>
    [...ordersQueryKeys.lists(), 'pending-approval-queue', params] as const,
  // Every order on one offering, for the offering detail drawer. Under lists()
  // so approve / reject / cancel already refresh it.
  offeringOrders: (offeringId: string) =>
    [...ordersQueryKeys.lists(), 'offering-orders', offeringId] as const,
  // Issuance readiness for one offering's orders (LST-04). Under lists()
  // because it IS a rollup of the order list — approving, rejecting or
  // re-registering an order changes it, and those mutations already invalidate
  // lists(), so the panel refreshes without any of them naming this key.
  vaspListingReadiness: (offeringId: string) =>
    [...ordersQueryKeys.lists(), 'vasp-listing-readiness', offeringId] as const,
}
